var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollabroSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "28 86 366.5 332",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 0 504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1557 3814c-400-201-726-368-723-372 8-13 1445-727 1451-721 3 3 4 332 3 731l-3 726-728-364z",
    fill: "#f58e20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2480 3450c0-401 3-730 8-729 4 0 333 164 732 363l725 364-733 366-732 366v-730z",
    fill: "#fab875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m830 3055v-195h-275-275l2-337 3-338 273-3 272-2v-195-195l732 366 733 366-725 364c-399 199-728 363-732 363-5 1-8-87-8-194z",
    fill: "#7a6d6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3200 2886-725-363 723-362c397-198 726-361 732-361 7 0 10 247 10 725 0 399-3 725-7 724-5 0-334-164-733-363z",
    fill: "#b3a8a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1553 1957c-398-199-723-364-723-367 0-5 1445-730 1455-730 3 0 5 329 5 730 0 402-3 730-7 729-5 0-333-163-730-362z",
    fill: "#f58e20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2480 1590c0-401 2-730 5-730 10 0 1455 725 1455 730s-1445 730-1455 730c-3 0-5-328-5-730z",
    fill: "#fab875"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabroSmall);
export default __webpack_public_path__ + "static/media/collabroSmall.c4720ffdb4b485577a88ba494c6e6ed7.svg";
export { ForwardRef as ReactComponent };